import React from 'react';
import { mockDestinations } from '../../data/mockFlights';

function CuratedEscapes({ onDestinationClick }) {
  return (
    <div>
      <div className="flex items-center justify-between mb-4">
        <div>
          <h2 className="text-lg font-bold text-on-surface">Curated Escapes</h2>
          <p className="text-xs text-on-surface-variant mt-0.5">Handpicked destinations for you</p>
        </div>
        <button className="text-sm font-medium text-primary hover:text-primary-dark transition-colors">
          See all
        </button>
      </div>

      <div className="grid grid-cols-2 gap-3">
        {/* Featured large card */}
        <DestinationCard
          destination={mockDestinations[0]}
          featured
          onClick={onDestinationClick}
        />
        <DestinationCard
          destination={mockDestinations[1]}
          featured
          onClick={onDestinationClick}
        />

        {/* Smaller cards */}
        {mockDestinations.slice(2).map((destination) => (
          <DestinationCard
            key={destination.id}
            destination={destination}
            onClick={onDestinationClick}
          />
        ))}
      </div>
    </div>
  );
}

function DestinationCard({ destination, featured = false, onClick }) {
  return (
    <button
      onClick={() => onClick && onClick(destination)}
      className={`relative overflow-hidden rounded-2xl group ${
        featured ? 'h-48' : 'h-36'
      }`}
    >
      {/* Background Image */}
      <div
        className="absolute inset-0 bg-cover bg-center transition-transform duration-500 group-hover:scale-110"
        style={{ backgroundImage: `url(${destination.image})` }}
      />

      {/* Gradient Overlay */}
      <div className={`absolute inset-0 bg-gradient-to-t ${destination.color}`} />

      {/* Content */}
      <div className="absolute inset-0 flex flex-col justify-end p-4">
        <p className="text-white font-bold text-base leading-tight">{destination.name}</p>
        <p className="text-white/70 text-xs mt-0.5">{destination.country}</p>
        <div className="flex items-baseline gap-1 mt-1.5">
          <span className="text-white/60 text-xs">from</span>
          <span className="text-white font-bold text-sm">${destination.startingPrice}</span>
        </div>
      </div>

      {/* Airport Code Badge */}
      <div className="absolute top-3 right-3 bg-white/15 backdrop-blur-md rounded-lg px-2.5 py-1">
        <span className="text-white text-xs font-bold tracking-wider">{destination.code}</span>
      </div>
    </button>
  );
}

export default CuratedEscapes;
